module.exports = __webpack_public_path__ + "img/posologie-hamid-schema.418b664e.png";